import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu";
import { Button } from "components/button";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "components/ui/tooltip";
import { SearchProductWithScore, SearchQuery } from "hooks/search/types";
import { CreateProjectDropdownItem } from "./CreateProjectDropdownItem";
import { AddToProjectDropdownItem } from "./AddToProjectDropdownItem";
import { ExportBooksDropdownItem } from "./ExportBooksDropdownItem";

interface TakeActionDropdownProps {
  disabled: boolean;
  isSelectedAll?: boolean;
  selectedBooksCount: number;
  selectedIds: string[];
  allBooksCount: number;
  products: SearchProductWithScore[];
  searchQuery: SearchQuery;
  fetchAllResults: () => Promise<SearchProductWithScore[]>;
}

export const TakeActionDropdown = ({
  disabled,
  isSelectedAll,
  selectedBooksCount,
  selectedIds,
  allBooksCount,
  products,
  searchQuery,
  fetchAllResults,
}: TakeActionDropdownProps) => {
  const { t } = useTranslation(["books", "general"]);
  return (
    <DropdownMenu>
      <Tooltip>
        <TooltipTrigger asChild>
          <span>
            <DropdownMenuTrigger asChild>
              <Button
                variant="primary"
                disabled={disabled}
                label={t("books:dropdown.takeAction.label")}
                icon="chevron-down"
                iconPosition="right"
                className="w-full h-10"
              />
            </DropdownMenuTrigger>
          </span>
        </TooltipTrigger>

        {disabled ? (
          <TooltipContent
            role="tooltip"
            side="bottom"
            className="font-light text-center shadow-tooltip text-secondary-600 whitespace-pre px-5 z-10 border-none"
            sideOffset={6}
          >
            <TooltipArrow
              className="fill-white drop-shadow-xs"
              width={12}
              height={6}
            />
            {t("books:dropdown.takeAction.disabled.noBooks")}
          </TooltipContent>
        ) : null}
      </Tooltip>

      <DropdownMenuContent
        side="bottom"
        align="center"
        className="popover-content-width-full"
      >
        <CreateProjectDropdownItem
          isSelectedAll={isSelectedAll}
          selectedBooksCount={selectedBooksCount}
          selectedIds={selectedIds}
          allBooksCount={allBooksCount}
          fetchAllResults={fetchAllResults}
        />

        <AddToProjectDropdownItem
          isSelectedAll={isSelectedAll}
          selectedBooksCount={selectedBooksCount}
          selectedIds={selectedIds}
          allBooksCount={allBooksCount}
          fetchAllResults={fetchAllResults}
        />
        <DropdownMenuSeparator />
        <ExportBooksDropdownItem
          isSelectedAll={isSelectedAll}
          selectedBooksCount={selectedBooksCount}
          selectedIds={selectedIds}
          products={products}
          searchQuery={searchQuery}
          fetchAllResults={fetchAllResults}
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
